import { Link } from "react-router-dom";
import { ArrowUpRight, Gem, Compass, BarChart3 } from "lucide-react";
import { GF_PATHWAYS, GROWTH_FACTOR_URL } from "../../data/config";
import { Reveal } from "../common/Reveal";

const ACCENTS = {
  emerald: { border: "border-t-emerald", icon: Gem, label: "text-emerald" },
  navy: { border: "border-t-navy", icon: Compass, label: "text-navy" },
  royal: { border: "border-t-royal", icon: BarChart3, label: "text-royal" },
};

export const GrowthFactorFeature = () => (
  <section className="bg-navy py-24 text-cream lg:py-32" data-testid="growth-factor-section">
    <div className="container-site">
      <div className="grid gap-12 lg:grid-cols-3">
        <Reveal className="lg:col-span-1">
          <p className="eyebrow">Growth Factor</p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight sm:text-4xl lg:text-5xl">
            BEFORE GROWTH COMES <span className="italic text-gold">DIAGNOSIS.</span>
          </h2>
          <p className="mt-6 text-sm leading-relaxed text-cream/70">
            Growth Factor is Irma Ariandi Global&apos;s digital diagnostic
            ecosystem — a reflective, developmental tool that brings clarity
            before action.
          </p>
          <a href={GROWTH_FACTOR_URL} target="_blank" rel="noreferrer" className="btn-gold mt-10" data-testid="growth-factor-cta">
            Explore Growth Factor <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
          </a>
        </Reveal>
        <div className="grid gap-6 sm:grid-cols-3 lg:col-span-2 lg:grid-cols-3">
          {GF_PATHWAYS.map((g, i) => {
            const accent = ACCENTS[g.accent];
            const Icon = accent.icon;
            return (
              <Reveal key={g.id} delay={i * 0.1} className="h-full">
                <Link to="/consulting/growth-factor" className="block h-full" aria-label={`${g.label} — Growth Factor`}>
                  <div
                    className={`flex h-full flex-col border border-cream/10 border-t-2 ${accent.border} bg-cream/5 p-7 transition-colors duration-300 hover:bg-cream/10`}
                    data-testid={`gf-card-${g.id}`}
                  >
                    <Icon className="h-6 w-6 text-gold" strokeWidth={1.25} aria-hidden="true" />
                    <h3 className="mt-6 font-serif text-lg leading-snug">{g.label}</h3>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-cream/65">{g.description}</p>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
      <p className="mt-14 border-t border-cream/10 pt-8 text-xs leading-relaxed text-cream/50" data-testid="gf-disclaimer">
        Growth Factor is a reflective and developmental diagnostic tool for
        personal and business clarity — it is not a clinical or psychological
        diagnosis.
      </p>
    </div>
  </section>
);
